import { render, staticRenderFns } from "./WorkoutSessionOverview.vue?vue&type=template&id=08437a87&scoped=true"
import script from "./WorkoutSessionOverview.vue?vue&type=script&lang=js"
export * from "./WorkoutSessionOverview.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSessionOverview.vue?vue&type=style&index=0&id=08437a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08437a87",
  null
  
)

export default component.exports